import { SocialPerson } from '@/models/Person';

export enum FollowerTypes {
    GET_FOLLOWERS_REQUEST = '@followers/GET_FOLLOWERS_REQUEST',
    GET_FOLLOWERS_SUCCESS = '@followers/GET_FOLLOWERS_SUCCESS',
    GET_FOLLOWERS_FAILURE = '@followers/GET_FOLLOWERS_FAILURE',

    SET_FOLLOWER_REQUEST = '@followers/SET_FOLLOWER_REQUEST',
    SET_FOLLOWER_SUCCESS = '@followers/SET_FOLLOWER_SUCCESS',
    SET_FOLLOWER_FAILURE = '@followers/SET_FOLLOWER_FAILURE',

    DELETE_FOLLOWER_REQUEST = '@followers/DELETE_FOLLOWER_REQUEST',
    DELETE_FOLLOWER_SUCCESS = '@followers/DELETE_FOLLOWER_SUCCESS',
    DELETE_FOLLOWER_FAILURE = '@followers/DELETE_FOLLOWER_FAILURE',

    GET_FOLLOWING_REQUEST = '@followers/GET_FOLLOWING_REQUEST',
    GET_FOLLOWING_SUCCESS = '@followers/GET_FOLLOWING_SUCCESS',
    GET_FOLLOWING_FAILURE = '@followers/GET_FOLLOWING_FAILURE',

    CLEAR_FOLLOWERS = '@followers/CLEAR_FOLLOWERS',
    CLEAR_TOTAL_FOLLOWERS = '@followers/CLEAR_TOTAL_FOLLOWERS',
    CLEAR_FOLLOWING = '@followers/CLEAR_FOLLOWING',

    INCREASE_FOLLOWING = '@followers/INCREASE_FOLLOWING',
    DECREASE_FOLLOWING = '@followers/DECREASE_FOLLOWING',

    BATCH_FOLLOW_REQUEST = '@followers/BATCH_FOLLOW_REQUEST',
    BATCH_FOLLOW_SUCCESS = '@followers/BATCH_FOLLOW_SUCCESS',
    BATCH_FOLLOW_FAILURE = '@followers/BATCH_FOLLOW_FAILURE',
}

export interface FollowersData {
    followers: SocialPerson[];
    following: SocialPerson[];
    totalFollowers: number;
    totalFollowing: number;
    immutableTotalFollowing: number;
}

export interface FollowersState {
    data: FollowersData;
    hasError: boolean;
    loading: boolean;
}

export type OnlyFollowersList = Pick<FollowersData, 'followers' | 'following'>;
